(function() {
    'use strict';
    angular.module('wbDashboard').factory('Account',
        ['$q', '$filter', '$uibModal', '$rootScope', 'Request', 'Track',
    function ($q, $filter, $uibModal, $rootScope, Request, Track) {

        var account = {};

        account.bankLinkStatuses = {
            active : "active",
            inactive : "inactive",
            waiting_for_verification : "waiting_for_verification",  // waiting for them to be entered
            declined: "declined",
            expired: "expired",
            invalid_bank : "invalid_bank",
        };
        account.bankLinkOldStatuses = {
            active : "ACTIVE",
            inactive : "INACTIVE",
            declined : "DECLINED",
            awaiting_verification : "AWAITING_VERIFICATION",
            to_be_initiated : "TO_BE_INITIATED",
            incorrect_info : "INCORRECT_INFO",
        };

        account.PIAModalTemplate = `
<div class="modal-header">
    <button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><span class="wbi wbi-close" aria-hidden="true"></span></button>
    <h2>Do you want to add a Personal Account?</h2>
</div>
<div class="modal-body">
    <p ng-if="hasRetirement">
        {{noun}} can't work its magic without one. This will add a Personal Account to your Retirement milestone
        and will initiate a $1 deposit, which will complete in 2-3 business days.
    </p>
    <p ng-if="!hasRetirement">
        {{noun}} can't work its magic without one. Add another milestone and one will be created for you.
    </p>
</div>
<div class="modal-footer">
    <button ng-if="hasRetirement" class="btn btn-primary" ng-click="$close()">Add Account</button>
    <button ng-if="!hasRetirement" class="btn btn-primary" ng-click="$dismiss()" ui-sref="base.milestone-mod.create.steps">Add Milestone</button>
</div>`;

        account.addPIAModal = function(retirementMSId, noun) {
            var modalScope = $rootScope.$new(true);
            modalScope.noun = noun;
            modalScope.hasRetirement = !!retirementMSId;
            var $uibModalInstance = $uibModal.open({
                template: account.PIAModalTemplate,
                scope:modalScope,
                size: 'md',
                backdrop: 'static',
                windowClass:'confirm-modal',
            });

            var data = {
                msId: retirementMSId,
                funding: {
                    account_type: "Personal Investment Account",
                    one_time_deposit: 1
                }
            };

            return $uibModalInstance.result.then(function() {
                return account.addMSAccount(data);
            }).then(function(response) {
                return response.data;
            }).catch(angular.noop);

        };

        /**
         *
         * @param {Object} data
         * @param {string} data.msId
         * @param {Object} data.funding
         * @param {number} data.funding.amount
         * @returns {*}
         */
        account.addMSAccount = function (data) {
            return Request.make("milestone_add_account", data);
        };
        
        /**
         * Add a new bank account
         *
         *
         * @param {Object} data
         *
         * For Plaid Accounts
         * @param {Object} data.plaid_bank
         * @param {String} data.plaid_bank.account_id
         * @param {String} data.plaid_bank.public_token
         * @param {Object} data.plaid_bank.account
         *
         * For ACH Accounts:
         * @param {string} data.name
         * @param {int}    data.routing_number
         * @param {string} data.account_number
         * @param {string} data.type
         * @param {string} data.public_token
         * @param {string} data.bank_id
         *
         * @returns {*}
         *
         */
        account.addBank = function (data) {
            return Request.make("bank_add", data);
        };

        /**
         * Cancel adding a new bank account
         * @returns {*}
         */
        account.cancelBank = function () {
            return Request.make("bank_cancel");
        };

        /**
         *
         * @param amount1
         * @param amount2
         * @returns {*}
         */
        account.verifyAchErrorCount = 0;
        account.verifyAch = function (amount1, amount2) {
            return Request.make("bank_confirm_micros", {
                amount_1: amount1,
                amount_2: amount2
            }).catch(function(response) {
                var error;
                var errorMessage = "There was an error on request, please try again";
                var refreshAccount = false;

                if (response.data && response.data.details && response.data.details[0]) {
                    error = response.data.details[0];
                    errorMessage = error.message;

                    switch (error.code) {
                        case 'MaxAttempts':
                            refreshAccount = true;
                            account.verifyAchErrorCount = 0;
                            break;
                        case 'Conflict':
                            account.verifyAchErrorCount++;
                            switch (true) {
                                case account.verifyAchErrorCount === 1:
                                    errorMessage = "Those amounts didn't look right. Please try again.";
                                    break;
                                case account.verifyAchErrorCount === 2:
                                    errorMessage = "Hmm... the amounts still aren't right. One attempt remaining.";
                                    break;
                                case account.verifyAchErrorCount > 2:
                                    errorMessage = "Our micro-deposits can only take so much... Please re-initiate.";
                                    refreshAccount = true;
                                    break;
                                default:
                                    errorMessage = "Hmm… these don’t match what was sent.";
                            }
                            break;
                        case 'NotBlank':
                            //could be anything
                            errorMessage += ". Please contact <a href=\"mailto:support@axosinvest.com\" target=\"_blank\">support@axosinvest.com</a>.";
                            break;

                    }
                }

                throw ( {message: errorMessage, refreshAccount: refreshAccount} );
            }).then(function(response) {
                account.verifyAchErrorCount = 0;
                if (typeof response.data === 'object' && "response" in response.data) {
                    return response.data.response.bank_account_link.status_name;
                }
            });
        };

        /**
         * Used for Plaid and ACH
         * For manual: Send ACH deposits again
         * For plaid: Relink plaid account
         * @returns {*}
         */
        account.reinitiateBank = function (bankId) {
            return Request.make("bank_relink", {bankId:bankId});
        };

        account.returnsHistoricalParse = function (data) {
            var chartData = {
                plotData: [],
                maxX: null,
                minX: null,
                maxY: null,
                minY: null
            };

            angular.forEach(data, function (holding) {
                var maxX, minX, maxY, minY, rangeY, originalMinY, precise;
                var newData;

                if (holding.historical_values.length) {

                    holding.historical_values.forEach(function (value, index) {

                        value.x = new Date(value.date).getTime();
                        value.y = value.account_value;

                        if (!maxX || maxX < value.x) maxX = value.x;
                        if (!minX || minX > value.x) minX = value.x;

                        if (!maxY || maxY < value.y) maxY = value.y;
                        if (!minY || minY > value.y) minY = value.y;

                    });

                    originalMinY = minY;

                    //rangeY = maxY - minY;
                    //maxY += rangeY * 0.10;
                    //
                    //minY -= rangeY * 0.10;
                    //if (temp > 0 && minY < 0) {
                    //    minY = 0;
                    //}

                    //Round to force only 2 significant figures, then add 1 to the second numbers place
                    precise = parseFloat(maxY.toPrecision(2));
                    maxY = precise + Math.round(parseFloat(Math.pow(10, precise.toString().length - 2)));

                    precise = parseFloat(minY.toPrecision(2));
                    minY = precise - Math.round(parseFloat(Math.pow(10, precise.toString().length - 2)));


                    newData = angular.copy(holding);
                    Object.assign(newData, {
                        values: holding.historical_values,
                        maxX: maxX,
                        minX: minX,
                        maxY: maxY,
                        minY: minY
                    });
                    delete newData.historical_values;

                    chartData.plotData.push(newData);
                }

            });

            chartData.plotData.forEach(function (plot) {
                if (!chartData.maxX || chartData.maxX < plot.maxX) chartData.maxX = plot.maxX;
                if (!chartData.minX || chartData.minX > plot.minX) chartData.minX = plot.minX;

                if (!chartData.maxY || chartData.maxY < plot.maxY) chartData.maxY = plot.maxY;
                if (!chartData.minY || chartData.minY > plot.minY) chartData.minY = plot.minY;
            });


            return chartData;
        };

        return account;

    }]);

})();
